<div class="" [class.opacity]="item.start ? item?.start?.active : false" (click)="onClickItem()">
    <div class="title border-bottom">
        <span class="ttl">{{item.title}}</span>
        <div class="date d-flex justify-content-between">
            <span class="text-primary"><i class="fa fa-calendar mr-1 op-5"></i>Del {{item?.date_start | moment:'ll'}} al {{item?.date_end | moment:'ll'}}</span>
            <!-- <span><i class="fa fa-circle mr-1 {{item.status?.label | lowercase}}"></i>{{typeName[item.status?.label]}}</span> -->
        </div>
    </div>
    <div class="bg-white">
        <div class="cert d-flex justify-content-between">
            <span># de Vacantes: <b>{{item.numero}}</b></span>
            <span class="bdg" *ngIf="item?.requirements?.length"><i class="fa fa-user mr-2"></i>{{item?.status?.label}}</span>
            
        </div>
        <div class="desc">
            {{item.description}}
        </div>
        <div class="address text-primary" *ngIf="item?.address"><i class="fa fa-building mr-2"></i> {{item?.address}}</div>
        <div class="bot border-top">
            <div class="_user">
                <div class="img"><img [src]="img | imagesLoad" alt=""></div>
                <div class="info">
                    <b>Reclutador</b>
                    <span>{{item.recruiter_agent}}</span>
                </div>
            </div>
            <div class="_user">
                <div class="info text-right">
                    <b>Empresa</b>
                    <span>{{item.recruiter_requester}}</span>
                </div>
                <div class="img"><img [src]="imgInstitution | imagesLoad" alt=""></div>
            </div>
        </div>
    </div>
</div>